var browser = require("bowser").getParser(window.navigator.userAgent),
    osName  = browser.getOSName().toLocaleLowerCase();

require("app/theme/assets/icons/artists.svg");
require("app/theme/assets/icons/dots-vertical.svg");
require("app/theme/assets/icons/email-color.svg");
require("app/theme/assets/icons/facebook-color.svg");
require("app/theme/assets/icons/follow-outline.svg");
require("app/theme/assets/icons/follow.svg");
require("app/theme/assets/icons/genres.svg");
require("app/theme/assets/icons/home-outline.svg");
require("app/theme/assets/icons/home-plus-outline.svg");
require("app/theme/assets/icons/minus.svg");
require("app/theme/assets/icons/playlist.svg");
require("app/theme/assets/icons/plus.svg");
require("app/theme/assets/icons/search.svg");
require("app/theme/assets/icons/settings.svg");
require("app/theme/assets/icons/share-alt.svg");
require("app/theme/assets/icons/share.svg");
require("app/theme/assets/icons/spinner.svg");
require("app/theme/assets/icons/whatsapp-color.svg");
require("app/theme/assets/icons/x-color.svg");
require("flag-icons/de.svg");
require("flag-icons/gb.svg");
require("flag-icons/nl.svg");
require("material-icons/account-child.svg");
require("material-icons/account-off.svg");
require("material-icons/account-plus.svg");
require("material-icons/account-remove.svg");
require("material-icons/account-star.svg");
require("material-icons/account.svg");
require("material-icons/arrow-bottom-right.svg");
require("material-icons/arrow-top-left.svg");
require("material-icons/cancel.svg");
require("material-icons/cart.svg");
require("material-icons/check.svg");
require("material-icons/chevron-down.svg");
require("material-icons/chevron-left.svg");
require("material-icons/chevron-right.svg");
require("material-icons/chevron-up.svg");
require("material-icons/close.svg");
require("material-icons/content-copy.svg");
require("material-icons/content-save.svg");
require("material-icons/credit-card-multiple.svg");
require("material-icons/download.svg");
require("material-icons/email-outline.svg");
require("material-icons/eye-off.svg");
require("material-icons/eye.svg");
require("material-icons/filter-variant.svg");
require("material-icons/fullscreen-exit.svg");
require("material-icons/fullscreen.svg");
require("material-icons/glasses.svg");
require("material-icons/headphones.svg");
require("material-icons/help-circle-outline.svg");
require("material-icons/information-outline.svg");
require("material-icons/information.svg");
require("material-icons/loading.svg");
require("material-icons/lock-open-outline.svg");
require("material-icons/lock-reset.svg");
require("material-icons/login.svg");
require("material-icons/logout.svg");
require("material-icons/magnify-minus-outline.svg");
require("material-icons/magnify-plus-outline.svg");
require("material-icons/magnify.svg");
require("material-icons/menu-down.svg");
require("material-icons/menu-left.svg");
require("material-icons/menu-right.svg");
require("material-icons/menu-up.svg");
require("material-icons/music.svg");
require("material-icons/pause.svg");
require("material-icons/pencil.svg");
require("material-icons/play-circle-outline.svg");
require("material-icons/play.svg");
require("material-icons/plus-circle-outline.svg");
require("material-icons/plus-circle.svg");
require("material-icons/podcast.svg");
require("material-icons/radiobox-blank.svg");
require("material-icons/radiobox-marked.svg");
require("material-icons/receipt-text.svg");
require("material-icons/refresh.svg");
require("material-icons/shield-account.svg");
require("material-icons/skip-backward.svg");
require("material-icons/skip-forward.svg");
require("material-icons/skip-next.svg");
require("material-icons/skip-previous.svg");
require("material-icons/toggle-switch-off.svg");
require("material-icons/toggle-switch.svg");
require("material-icons/trash-can.svg");
require("material-icons/trending-up.svg");
require("material-icons/view-column.svg");

module.exports = {

    // App Header
    // --------------------------------

    "app.AppHeader.HeaderView.backButton":                         "chevron-left",
    "app.AppHeader.HeaderView.PreviewModeButton.loading":          "loading",
    "app.AppHeader.HeaderView.PreviewModeButton.previewModeOn":    "toggle-switch",
    "app.AppHeader.HeaderView.PreviewModeButton.previewModeOff":   "toggle-switch-off",
    "app.AppHeader.HeaderView.searchButton":                       "search",
    "app.AppHeader.HeaderView.playlistsButton":                    "playlist",
    "app.AppHeader.HeaderView.BookmarksButton.loading":            "loading",
    "app.AppHeader.HeaderView.BookmarksButton.loaded":             "plus",
    "app.AppHeader.HeaderView.genresButton":                       "genres",
    "app.AppHeader.HeaderView.artistsButton":                      "artists",
    "app.AppHeader.HeaderView.CategoryDropdown.Activator.loading": "loading",
    "app.AppHeader.HeaderView.CategoryDropdown.Activator.loaded":  "menu-down",
    "app.AppHeader.HeaderView.BrandDropdown.Activator.loading":    "loading",
    "app.AppHeader.HeaderView.BrandDropdown.Activator.loaded":     "menu-down",
    "app.AppHeader.HeaderView.LoginButton.loading":                "loading",
    "app.AppHeader.HeaderView.LoginButton.loggedIn":               null,
    "app.AppHeader.HeaderView.LoginButton.loggedOut":              null,
    "app.AppHeader.HeaderView.signUpButton":                       null,

    "app.AppHeader.LanguageSwitcher.LanguageIcon.nl": "nl",
    "app.AppHeader.LanguageSwitcher.LanguageIcon.de": "de",
    "app.AppHeader.LanguageSwitcher.LanguageIcon.en": "gb",
    "app.AppHeader.LanguageSwitcher.loading":         "loading",

    "app.AppHeader.MenuDropdown.Activator":                          "dots-vertical",
    "app.AppHeader.MenuDropdown.PreviewModeButton.loading":          "loading",
    "app.AppHeader.MenuDropdown.PreviewModeButton.previewModeOn":    "toggle-switch",
    "app.AppHeader.MenuDropdown.PreviewModeButton.previewModeOff":   "toggle-switch-off",
    "app.AppHeader.MenuDropdown.homeButton":                         "home-outline",
    "app.AppHeader.MenuDropdown.signUpButton":                       "account-plus",
    "app.AppHeader.MenuDropdown.LoginButton.loading":                "loading",
    "app.AppHeader.MenuDropdown.LoginButton.loggedIn":               "check",
    "app.AppHeader.MenuDropdown.LoginButton.loggedOut":              "login",
    "app.AppHeader.MenuDropdown.addToHomeScreenButton":              "home-plus-outline",
    "app.AppHeader.MenuDropdown.searchButton":                       "search",
    "app.AppHeader.MenuDropdown.playlistsButton":                    "playlist",
    "app.AppHeader.MenuDropdown.BookmarksButton.loading":            "loading",
    "app.AppHeader.MenuDropdown.BookmarksButton.loaded":             "plus",
    "app.AppHeader.MenuDropdown.genresButton":                       "genres",
    "app.AppHeader.MenuDropdown.artistsButton":                      "artists",
    "app.AppHeader.MenuDropdown.CategoryDropdown.Activator.loading": "loading",
    "app.AppHeader.MenuDropdown.CategoryDropdown.Activator.loaded":  "menu-down",
    "app.AppHeader.MenuDropdown.BrandDropdown.Activator.loading":    "loading",
    "app.AppHeader.MenuDropdown.BrandDropdown.Activator.loaded":     "menu-down",
    "app.AppHeader.MenuDropdown.privacyButton":                      "shield-account",
    "app.AppHeader.MenuDropdown.cookiePreferencesButton":            "settings",
    "app.AppHeader.MenuDropdown.faqButton":                          "help-circle-outline",
    "app.AppHeader.MenuDropdown.contactButton":                      "email-outline",

    // App Layout
    // --------------------------------

    "app.AppLayout.MediaDetailsPopup.closeButton": "close",

    // Auth
    // --------------------------------

    "app.Auth.SignUpButton": "account-plus",

    "app.Auth.ContinueSignUpPopup.yepButton":  "account-plus",
    "app.Auth.ContinueSignUpPopup.nopeButton": "logout",

    "app.Auth.LoginButton.authenticating": "loading",
    "app.Auth.LoginButton.loggedIn":       "check",
    "app.Auth.LoginButton.loggedOut":      "login",

    "app.Auth.ProfileButton": "account",

    "app.Auth.LogoutButton.authenticating": "loading",
    "app.Auth.LogoutButton.loggedIn":       "logout",
    "app.Auth.LogoutButton.loggedOut":      "check",

    // Artist Page
    // --------------------------------

    "app.ArtistPage.PlaylistItem.infoButton": "information-outline",

    // Bookmark Page
    // --------------------------------

    "app.BookmarkPage.GridPageView.editButton": "pencil",

    // Bookmarks
    // --------------------------------

    "app.Bookmarks.BookmarkButton.loading":    "loading",
    "app.Bookmarks.BookmarkButton.bookmark":   "plus",
    "app.Bookmarks.BookmarkButton.unbookmark": "minus",

    "app.Bookmarks.BookmarkButtonAlt.bookmark":   "plus-circle-outline",
    "app.Bookmarks.BookmarkButtonAlt.unbookmark": "plus-circle",

    "app.Bookmarks.LoginCta.cancelButton": "cancel",

    // Following
    // --------------------------------

    "app.Following.FollowButton.loading":  "loading",
    "app.Following.FollowButton.follow":   "follow-outline",
    "app.Following.FollowButton.unfollow": "follow",

    // ForgotPassword Page
    // --------------------------------

    "app.ForgotPasswordPage.PageView.submitButton":  "lock-reset",
    "app.ForgotPasswordPage.PageView.successButton": "login",

    // Fotocadeau
    // --------------------------------

    "app.Fotocadeau.BuyButton.loading": "loading",
    "app.Fotocadeau.BuyButton.buy":     "cart",
    "app.Fotocadeau.BuyButton.buyAlt":  "chevron-right",

    // Home Page
    // --------------------------------

    "app.HomePage.HeaderContent.ctaButton": null,

    "app.HomePage.TemporarilyOfflinePageView.button": "refresh",

    // Login Page
    // --------------------------------

    "app.LoginPage.PageView.emailLoginButton":                "login",
    "app.LoginPage.PageView.passwordVisibility.hidePassword": "eye-off",
    "app.LoginPage.PageView.passwordVisibility.showPassword": "eye",

    // Magazine Page
    // --------------------------------

    "app.MagazinePage.MultiYearCarouselRow.activator": "chevron-right",
    "app.MagazinePage.MultiYearGridRow.activator":     "chevron-right",

    "app.MagazinePage.YearMenuButton.active":   "check",
    "app.MagazinePage.YearMenuButton.inactive": null,

    // Media Detail Popup
    // --------------------------------

    "app.MediaDetailPopup.closeButton":   "close",
    "app.MediaDetailPopup.liveBadgeIcon": "radiobox-marked",
    "app.MediaDetailPopup.backButton":    "chevron-left",

    // Media Player
    // --------------------------------

    "app.MediaPlayer.AudioView.expandButton": "arrow-top-left",
    "app.MediaPlayer.AudioView.backButton":   "arrow-bottom-right",
    "app.MediaPlayer.AudioView.closeButton":  "close",

    "app.MediaPlayer.ConfirmActivityPopup.yepButton":  "play-circle-outline",
    "app.MediaPlayer.ConfirmActivityPopup.nopeButton": "cancel",

    "app.MediaPlayer.AdsRequiredView.yepButton":  "settings",
    "app.MediaPlayer.AdsRequiredView.nopeButton": "cancel",

    "app.MediaPlayer.FatalErrorView.button": "refresh",

    "app.MediaPlayer.PlayMediaButton.audio": "headphones",
    "app.MediaPlayer.PlayMediaButton.text":  "glasses",
    "app.MediaPlayer.PlayMediaButton.video": "play",
    "app.MediaPlayer.PlayMediaButton.image": "eye",

    "app.MediaPlayer.PlayPauseButton.loading": "loading",
    "app.MediaPlayer.PlayPauseButton.playing": "pause",
    "app.MediaPlayer.PlayPauseButton.paused":  "play",

    "app.MediaPlayer.PlayPauseNavButton.loading":        "loading",
    "app.MediaPlayer.PlayPauseNavButton.playing":        "pause",
    "app.MediaPlayer.PlayPauseNavButton.paused":         "play",
    "app.MediaPlayer.PlayPauseNavButton.differentMedia": "play",

    "app.MediaPlayer.PrevNextButton.prevIcon": "skip-previous",
    "app.MediaPlayer.PrevNextButton.nextIcon": "skip-next",

    "app.MediaPlayer.TooManySessionsView.yepButton":  "play-circle-outline",
    "app.MediaPlayer.TooManySessionsView.nopeButton": "cancel",

    "app.MediaPlayer.UnsuspendView.yepButton":  "lock-open-outline",
    "app.MediaPlayer.UnsuspendView.nopeButton": "cancel",

    "app.MediaPlayer.VideoView.expandButton": "arrow-top-left",
    "app.MediaPlayer.VideoView.closeButton":  "close",

    "app.MediaPlayer.ImageReader.Toolbar.zoomOutButton":        "magnify-minus-outline",
    "app.MediaPlayer.ImageReader.Toolbar.zoomInButton":         "magnify-plus-outline",
    "app.MediaPlayer.ImageReader.Toolbar.firstPageButton":      "skip-backward",
    "app.MediaPlayer.ImageReader.Toolbar.previousPageButton":   "skip-previous",
    "app.MediaPlayer.ImageReader.Toolbar.browseButton":         "view-column",
    "app.MediaPlayer.ImageReader.Toolbar.nextPageButton":       "skip-next",
    "app.MediaPlayer.ImageReader.Toolbar.lastPageButton":       "skip-forward",
    "app.MediaPlayer.ImageReader.Toolbar.fullscreenButton":     "fullscreen",
    "app.MediaPlayer.ImageReader.Toolbar.exitFullscreenButton": "fullscreen-exit",

    "app.MediaPlayer.ImageReader.ZoomDropdown.activator":     "magnify",
    "app.MediaPlayer.ImageReader.ZoomDropdown.zoomInButton":  "magnify-plus-outline",
    "app.MediaPlayer.ImageReader.ZoomDropdown.zoomOutButton": "magnify-minus-outline",

    "app.MediaPlayer.ImageViewer.previousImageButton": "chevron-left",
    "app.MediaPlayer.ImageViewer.nextImageButton":     "chevron-right",

    "app.MediaPlayer.ImageViewer.Toolbar.zoomOutButton":                 "magnify-minus-outline",
    "app.MediaPlayer.ImageViewer.Toolbar.zoomInButton":                  "magnify-plus-outline",
    "app.MediaPlayer.ImageViewer.Toolbar.fullscreenButton":              "fullscreen",
    "app.MediaPlayer.ImageViewer.Toolbar.exitFullscreenButton":          "fullscreen-exit",
    "app.MediaPlayer.ImageViewer.Toolbar.infoButton.descriptionShowing": "information",
    "app.MediaPlayer.ImageViewer.Toolbar.infoButton.descriptionHidden":  "information-outline",

    // Music Album Page
    // --------------------------------

    "app.MusicAlbumPage.AlbumTrack.infoIcon": "information-outline",
    "app.MusicAlbumPage.AlbumTrack.playIcon": "play",

    "app.MusicAlbumPage.MusicAlbumRow.icon": "music",

    // Oops Page
    // --------------------------------

    "app.OopsPage.PageView.button": "chevron-right",

    // Page Page
    // --------------------------------

    "app.PagePage.ContentTypeMenuButton": "menu-down",

    // Playlist Page
    // --------------------------------

    "app.PlaylistPage.PlaylistItem.infoButton": "information-outline",

    // Podcast Page
    // --------------------------------

    "app.PodcastPage.PodcastEpisode.infoIcon": "information-outline",
    "app.PodcastPage.PodcastEpisode.playIcon": "play",

    "app.PodcastPage.PodcastRow.icon": "podcast",

    // Product Page
    // --------------------------------

    "app.ProductPage.ContentTypeMenuButton": "menu-down",

    // Profile Page
    // --------------------------------

    "app.ProfilePage.ChangeEmailButton": "email-outline",

    "app.ProfilePage.ChangeEmailForm.showPassword":            "eye",
    "app.ProfilePage.ChangeEmailForm.hidePassword":            "eye-off",
    "app.ProfilePage.ChangeEmailForm.submitButton.neutral":    "content-save",
    "app.ProfilePage.ChangeEmailForm.submitButton.submitting": "loading",

    "app.ProfilePage.ChangeIsAdultButton": "account-child",

    "app.ProfilePage.ChangeIsAdultForm.showPassword":            "eye",
    "app.ProfilePage.ChangeIsAdultForm.hidePassword":            "eye-off",
    "app.ProfilePage.ChangeIsAdultForm.submitButton.neutral":    "content-save",
    "app.ProfilePage.ChangeIsAdultForm.submitButton.submitting": "loading",
    "app.ProfilePage.ChangeIsAdultForm.isKidIcon.checked":       "radiobox-marked",
    "app.ProfilePage.ChangeIsAdultForm.isKidIcon.unchecked":     "radiobox-blank",
    "app.ProfilePage.ChangeIsAdultForm.isAdultIcon.checked":     "radiobox-marked",
    "app.ProfilePage.ChangeIsAdultForm.isAdultIcon.unchecked":   "radiobox-blank",

    "app.ProfilePage.ChangePasswordButton": "lock-reset",

    "app.ProfilePage.ChangePasswordForm.showCurrentPassword":     "eye",
    "app.ProfilePage.ChangePasswordForm.hideCurrentPassword":     "eye-off",
    "app.ProfilePage.ChangePasswordForm.showNewPassword":         "eye",
    "app.ProfilePage.ChangePasswordForm.hideNewPassword":         "eye-off",
    "app.ProfilePage.ChangePasswordForm.showNewPassword2":        "eye",
    "app.ProfilePage.ChangePasswordForm.hideNewPassword2":        "eye-off",
    "app.ProfilePage.ChangePasswordForm.submitButton.neutral":    "content-save",
    "app.ProfilePage.ChangePasswordForm.submitButton.submitting": "loading",

    "app.ProfilePage.ChangePaymentButton": "credit-card-multiple",

    "app.ProfilePage.PaymentsPopupButton": "receipt-text",

    "app.ProfilePage.PaymentTableRow.downloadButton": "download",

    "app.ProfilePage.RemoveAccountButton.neutral":    "account-remove",
    "app.ProfilePage.RemoveAccountButton.submitting": "loading",

    "app.ProfilePage.RemoveAccountVerificationMessage.yepButton":  "account-remove",
    "app.ProfilePage.RemoveAccountVerificationMessage.nopeButton": "cancel",

    "app.ProfilePage.ResubscribeButton.neutral":    "account-star",
    "app.ProfilePage.ResubscribeButton.submitting": "loading",

    "app.ProfilePage.ResubscribeVerificationMessage.yepButton":  "account-star",
    "app.ProfilePage.ResubscribeVerificationMessage.nopeButton": "cancel",

    "app.ProfilePage.UnsubscribeButton.neutral":    "account-off",
    "app.ProfilePage.UnsubscribeButton.submitting": "loading",

    "app.ProfilePage.UnsubscribeVerificationMessage.yepButton":  "account-off",
    "app.ProfilePage.UnsubscribeVerificationMessage.nopeButton": "cancel",

    "app.ProfilePage.UnsuspendButton": "lock-open-outline",

    "app.ProfilePage.UpgradeButton": "trending-up",

    // Search Page
    // --------------------------------

    "app.SearchPage.SearchForm.clearButton":               "close",
    "app.SearchPage.SearchForm.searchButton":              "search",
    "app.SearchPage.SearchForm.TypeFilterButton.active":   "check",
    "app.SearchPage.SearchForm.TypeFilterButton.inactive": null,
    "app.SearchPage.TypeFilterDropdown.Activator":         "filter-variant",

    // Series Page
    // --------------------------------

    "app.SeriesPage.MultiSeasonCarouselRow.activator": "chevron-right",
    "app.SeriesPage.MultiSeasonGridRow.activator":     "chevron-right",

    "app.SeriesPage.SeasonMenuButton.active":   "check",
    "app.SeriesPage.SeasonMenuButton.inactive": null,

    // Sharing
    // --------------------------------

    "app.Sharing.ShareButton.share":   osName === "android" ? "share-alt" : "share",
    "app.Sharing.ShareButton.loading": "loading",

    "app.Sharing.SharePopup.closeButton": "close",
    "app.Sharing.SharePopup.copyButton":  "content-copy",

    "app.Sharing.SharePopup.facebook": "facebook-color",
    "app.Sharing.SharePopup.whatsapp": "whatsapp-color",
    "app.Sharing.SharePopup.x":        "x-color",
    "app.Sharing.SharePopup.email":    "email-color",

    // UI
    // --------------------------------

    "app.ui.CategoryRowPlaceholder.spinner": "spinner",

    "app.ui.header.MediaHeader.previousSlideButton": "chevron-left",
    "app.ui.header.MediaHeader.nextSlideButton":     "chevron-right",

    "app.ui.LargeMediaHeader.liveBadgeIcon": "radiobox-marked",

    "app.ui.Popup.closeButton": "close",

    "app.ui.ScrollerDecoratorCarousel.scrollButtonBackward": "chevron-left",
    "app.ui.ScrollerDecoratorCarousel.scrollButtonForward":  "chevron-right",

    "app.ui.ScrollerDecoratorScrollbars.scrollButtonUp":    "menu-up",
    "app.ui.ScrollerDecoratorScrollbars.scrollButtonDown":  "menu-down",
    "app.ui.ScrollerDecoratorScrollbars.scrollButtonLeft":  "menu-left",
    "app.ui.ScrollerDecoratorScrollbars.scrollButtonRight": "menu-right",

    "app.ui.ScrollerPopup.closeButton": "close",

    "app.ui.Spinner": "spinner",

    "app.ui.covers.AlbumTrackCover.playIcon":     "headphones",
    "app.ui.covers.AudioCover.playIcon":          "headphones",
    "app.ui.covers.BookCover.playIcon":           "glasses",
    "app.ui.covers.EpisodeCover.playIcon":        "play",
    "app.ui.covers.IssueCover.playIcon":          "glasses",
    "app.ui.covers.MagazineCover.playIcon":       "glasses",
    "app.ui.covers.MediaCover.liveIcon":          "radiobox-marked",
    "app.ui.covers.MusicAlbumCover.playIcon":     "headphones",
    "app.ui.covers.Podcast.playIcon":             "headphones",
    "app.ui.covers.PodcastEpisodeCover.playIcon": "headphones",
    "app.ui.covers.SeriesCover.playIcon":         "play",
    "app.ui.covers.VideoCover.playIcon":          "play",

    "app.ui.header.HorizontalDescription.liveIcon":  "radiobox-marked",
    "app.ui.header.HorizontalDescription.readMore":  "chevron-right",
    "app.ui.header.HorizontalDescription.ctaButton": null,

    "app.ui.header.VerticalDescription.liveIcon":  "radiobox-marked",
    "app.ui.header.VerticalDescription.ctaButton": null,
    "app.ui.header.VerticalDescription.showLess":  "chevron-up",
    "app.ui.header.VerticalDescription.readMore":  "chevron-down",

    "app.ui.repeaters.CarouselRow.moreButton": "chevron-right",

    "app.ui.repeaters.GridRow.moreButton": "chevron-right",

    "app.ui.thumbnails.AlbumTrackThumbnail.playIcon":             "headphones",
    "app.ui.thumbnails.AudioThumbnail.playIcon":                  "headphones",
    "app.ui.thumbnails.BookmarkAlbumTrackThumbnail.playIcon":     "headphones",
    "app.ui.thumbnails.BookmarkAudioThumbnail.playIcon":          "headphones",
    "app.ui.thumbnails.BookmarkBookThumbnail.playIcon":           "glasses",
    "app.ui.thumbnails.BookmarkEpisodeThumbnail.playIcon":        "play",
    "app.ui.thumbnails.BookmarkIssueThumbnail.playIcon":          "glasses",
    "app.ui.thumbnails.BookmarkPhotoThumbnail.playIcon":          "eye",
    "app.ui.thumbnails.BookmarkPodcastEpisodeThumbnail.playIcon": "headphones",
    "app.ui.thumbnails.BookmarkThumbnail.liveIcon":               "radiobox-marked",
    "app.ui.thumbnails.BookmarkThumbnail.infoIcon":               "information-outline",
    "app.ui.thumbnails.BookmarkThumbnail.deleteIcon":             "trash-can",
    "app.ui.thumbnails.BookmarkVideoThumbnail.playIcon":          "play",
    "app.ui.thumbnails.BookThumbnail.playIcon":                   "glasses",
    "app.ui.thumbnails.EpisodeThumbnail.playIcon":                "play",
    "app.ui.thumbnails.IssueThumbnail.playIcon":                  "glasses",
    "app.ui.thumbnails.MagazineThumbnail.playIcon":               "glasses",
    "app.ui.thumbnails.MediaThumbnail.liveIcon":                  "radiobox-marked",
    "app.ui.thumbnails.MediaThumbnail.infoIcon":                  "information-outline",
    "app.ui.thumbnails.MusicAlbumThumbnail.playIcon":             "glasses",
    "app.ui.thumbnails.PhotoThumbnail.playIcon":                  "eye",
    "app.ui.thumbnails.PodcastEpisodeThumbnail.playIcon":         "headphones",
    "app.ui.thumbnails.PodcastThumbnail.playIcon":                "headphones",
    "app.ui.thumbnails.SeriesThumbnail.playIcon":                 "play",
    "app.ui.thumbnails.VideoThumbnail.playIcon":                  "play",

    // Upgrade Required Page
    // --------------------------------

    "app.UpgradeRequiredPage.UpgradeCtaPageView.yepButton":  "trending-up",
    "app.UpgradeRequiredPage.UpgradeCtaPageView.nopeButton": "cancel",

    // User Required Page
    // --------------------------------

    "app.UserRequiredPage.LoginCta.cancelButton": "cancel"
};
